import { render, staticRenderFns } from "./BrainCancerDependencyPage.vue?vue&type=template&id=01fb0f8a&scoped=true"
var script = {}
import style0 from "./BrainCancerDependencyPage.vue?vue&type=style&index=0&id=01fb0f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb0f8a",
  null
  
)

export default component.exports